import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faKey } from '@fortawesome/pro-light-svg-icons/faKey'
import { faRectangleTerminal } from '@fortawesome/pro-light-svg-icons/faRectangleTerminal'
import { faRocketLaunch } from '@fortawesome/pro-light-svg-icons/faRocketLaunch'
import { faUser } from '@fortawesome/pro-light-svg-icons/faUser'

import StepSendFirstRequest from 'components/gettingStartedTour/StepSendFirstRequest'
import StepStartBuilding from 'components/gettingStartedTour/StepStartBuilding'
import StepViewApiKey from 'components/gettingStartedTour/StepViewApiKey'
import { IStepsComponent } from 'components/gettingStartedTour/types'

export const GST_IS_SYNC_REQUEST = 'gst_nmfSXMXNI'

export const steps: Array<{ component: React.FC<IStepsComponent>; icon: IconDefinition; id: string; label: string }> = [
  {
    component: StepViewApiKey,
    icon: faUser,
    id: 'create-account',
    label: 'Create Account'
  },
  {
    component: StepViewApiKey,
    icon: faKey,
    id: 'view-api',
    label: 'View your API key'
  },
  {
    component: StepSendFirstRequest,
    icon: faRectangleTerminal,
    id: 'send-request',
    label: 'Send first request'
  },
  {
    component: StepStartBuilding,
    icon: faRocketLaunch,
    id: 'start-building',
    label: 'Start building'
  }
]
